import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';

@Component({
  selector: 'app-profissional-listar',
  templateUrl: './profissional-listar.component.html',
  styleUrls: ['./profissional-listar.component.scss']
})
export class ProfissionalListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loadingProfissionais: boolean = false;
  empresaSelecionada?: Empresa;
  profissionais: Profissional[] = [];
  situacoesStatus: SelectItem[] = [
    { label: 'ATIVOS', value: 1 },
    { label: 'INATIVOS', value: 0 }
  ];
  statusSelecionado: number = 1;

  constructor(private profissionalService: ProfissionalService,
    private confirmationService: ConfirmationService,
    utilStorageService: UtilStorageService,
    erroService: ErroService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute) {
    super(erroService, utilStorageService)
  }

  ngOnInit(): void {
    this.loadingProfissionais = true;
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    if (this.permissaoListar) {
      this.listarProfissionais();
    }
  }

  listarProfissionais() {
    if (this.statusSelecionado == 1) {
      this.profissionalService.listarAtivosPorEmpresaId(this.empresaSelecionada?.id).subscribe({
        next: (data: Profissional[]) => {
          this.profissionais = data;
          this.loadingProfissionais = false;
        },
        error: (err: any) => {
          this.loadingProfissionais = false;
          this.exibirMensagemErro(err);
        }
      });
    } else {
      this.profissionalService.listarInativosPorEmpresaId(this.empresaSelecionada?.id).subscribe({
        next: (data: Profissional[]) => {
          this.profissionais = data;
          this.loadingProfissionais = false;
        },
        error: (err: any) => {
          this.loadingProfissionais = false;
          this.exibirMensagemErro(err);
        }
      });
    }

  }

  excluir(profissionalId: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.profissionalService.excluir(profissionalId).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.rolarTela();
            this.listarProfissionais()
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  detalhar(profissionalId?: number) {
    this._router.navigate(["/apps/profissional/detalhar/" + profissionalId], { relativeTo: this._activatedRoute })
  }

  editar(profissionalId?: number) {
    this._router.navigate(["/apps/profissional/editar/" + profissionalId], { relativeTo: this._activatedRoute })
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_PROFISSIONAL');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_PROFISSIONAL');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_PROFISSIONAL');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_PROFISSIONAL');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_PROFISSIONAL');
  }

}
